export default {"src":"/_next/static/media/bell.08c26f4e.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};